import axios from "axios";

const API = axios.create({
  baseURL: "https://homefoods-backend-production.up.railway.app/api",
});

// Attach JWT Token
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ===============================
// Get Preferences
// ===============================

export const getPreferences = async () => {
  const response = await API.get("/provider-settings/preferences");
  return response.data;
};

// ===============================
// Update Preferences
// ===============================

export const updatePreferences = async (preferences) => {
  const response = await API.put(
    "/provider-settings/preferences",
    preferences
  );

  return response.data;
};